<mat-drawer-container class="countable-drawer">

  <mat-drawer-content class="overflow-hidden">
    <div class="page-wraper bg-gray-50">
      <div class="page-title-block workbook-title-block align-items-start">
        <div class="left-content title-block-left button-group flex-row header-actions">
          <button mat-button mat-stroked-button color="dark" class="btn-medium-icon" title="Collapse All"
            *ngIf="retainedEarningsExpanded" (click)="expandAndCollapse('collapse')">
            <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center fs-3 text-primary"></i>
          </button>
          <button mat-button mat-stroked-button color="dark" class="btn-medium-icon" title="Expand All"
            (click)="expandAndCollapse('expand')" *ngIf="!retainedEarningsExpanded">
            <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center fs-3 text-primary"></i>
          </button>
          <button mat-button mat-stroked-button title="Refresh" color="dark" class="btn-medium-icon"
            (click)="refreshRetainedEarnings()"
            [disabled]="(firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress) || shortCutMenuDetails.isenglock !== 0">
            <i class="fa-regular fa-arrows-rotate"></i>
          </button>
        </div>
        <div class="title-block-middle flexbox-column gap-0 flex-1 align-items-center">

          <h3 class="title">{{clientName}}</h3>
          <h3 class="title">{{headerNotesColumn1}}</h3>

          <!--2nd Column-->
          <div class="flexbox-row gap-8 justify-content-center">
            <ng-container *ngIf="isSecondColumnClicked">
              <mat-form-field class="fixed-label form-field-medium icon-form-after action-2 label-none"
                style="width: 300px">
                <input matInput placeholder="" [(ngModel)]="headerNotesColumn2" type="text" class="edit-field" />

                <div matSuffix class="actions border-start">
                  <button mat-button mat-icon-button color="success" class="done-btn" (click)="saveHeaderNote()"
                          [disabled]="!acl?.hasEngViewEdit">
                    <i class="fa-regular fa-check"></i>
                  </button>
                  <button mat-button mat-icon-button class="clear-btn" color="cancel"
                    (click)="isSecondColumnClicked = false; headerNotesColumn2 = isOldSecondColumn">
                    <i class="fa-regular fa-xmark"></i>
                  </button>

                </div>
              </mat-form-field>
              <h6 class="title">{{currentYear | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}</h6>

            </ng-container>
            <ng-container *ngIf="!isSecondColumnClicked">
              <span style="position: relative;display: inline-block;" class="hover-action">
                <h6 class="title hover-action d-flex flex-row align-items-center gap-8" style="min-height:36px;">
                  {{headerNotesColumn2}} {{currentYear | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}
                    <ng-container *ngIf="acl?.hasEngViewEdit">
                    <button mat-button class="button-text hover-action-item"
                      *ngIf="shortCutMenuDetails.isenglock === 0 && !isHideActionsForPY"
                      (click)="isSecondColumnClicked = true; isThirdColumnClicked = false; isOldSecondColumn = headerNotesColumn2">
                      <i class="fa-regular fa-pen fs-15"></i>
                    </button>
                  </ng-container>
                </h6>
              </span>
            </ng-container>
          </div>

        </div>
        <div class="title-block-right d-none d-lg-flex"></div>
      </div>

      <mat-accordion>
        <mat-expansion-panel class="plan-expansion body-expansion" expanded="true">
            <mat-expansion-panel-header class="d-block d-lg-none filter-actions-button">
                <mat-panel-title>
                        <div class="plan-expansion-header">
                            <button mat-button mat-stroked-button color="dark" class="button-medium">
                                <span class="flexbox-row gap-8 flex-nowrap">
                                    <span class="title">Actions</span>
                                    <span class="toggle-icon dot-16 bg-transparent"></span>
                                </span>
                            </button>
                        </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="plan-expansion-body">

                <div class="sorting-block d-flex flex-row align-items-end justify-content-between p-24">
                  <div class="sorting-block-left d-flex flex-row align-items-end form-group row-item-2">


                    <mat-form-field class="form-item fixed-label" floatLabel="always">
                      <mat-label>Entity Name</mat-label>
                      <mat-select [(value)]="clientName" [disabled]=true title="{{clientName}}">
                        <mat-option value="{{clientName}}">
                          {{clientName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="form-item ng-form-field">
                      <label>Year End Date</label>
                      <ng-select placeholder="" [items]="yearEndDetails" [clearable]="false" [clearOnBackspace]="false"
                        bindValue="acctyear" bindLabel="acctdate" [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="selectedYearEnd" [title]="currentYear | appCountableTimeZone: 'MMM d, y':'UTC'" name="year end"
                        (change)="refreshRetainedEarnings()" class="yr-dropdown">
                        <ng-template ng-option-tmp ng-label-tmp let-item="item">
                          {{ item.acctdate | appCountableTimeZone: 'MMM d, y':'UTC'}}
                       </ng-template>
                      </ng-select>
                    </div>
                  </div>

                  <form class="sorting-block-right">
                    <mat-form-field class="fixed-label label-none icon-field-before" floatLabel="always">
                      <mat-label>Search</mat-label>
                      <input matInput placeholder="Search" #searchField [(ngModel)]="searchText"
                        [ngModelOptions]="{standalone: true}" (keyup)="handleSearch($event.target.value)" autocomplete="off">
                      <span matPrefix>
                          <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                      </span>
                    </mat-form-field>
                  </form>

                </div>
            </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- <div class="retained-earnings-wrapper"> -->
      <div class="content-block-main overflow-hidden template-block-main">
        <div class="retained-earnings-container-body-grid card h-100 overflow-auto w-100">
          <div class="flex-table fixed-header hover-action">
            <div class="flex-table-header fixed-top">
              <div class="table-left-section">
                <p class="ft-header-cell col-status"></p>
                <p class="ft-header-cell col-group flex-1">
                  <span class="ps-2">Group Name</span>
                </p>
              </div>
              <p class="ft-header-cell col-leadsheet border-start">LS</p>
              <p class="ft-header-cell col-map">Map No.</p>
              <p class="ft-header-cell col-nfs border-start" *ngIf="restrictedColumn">
                <span>Notes to FS</span>
              </p>
              <p class="ft-header-cell col-current flex-column gap-0 align-items-end" title="{{currentYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                <span>{{currentYear | appCountableTimeZone:'MMMM d':'UTC'}}</span>
                <span>{{currentYear | appCountableTimeZone:'yyyy':'UTC'}}</span>
              </p>
              <ng-container *ngIf="isPrevyear">
                  <p class="ft-header-cell col-previous flexbox-row gap-8 flex-nowrap border-start">
                    <span class="flexbox-column gap-0 align-items-end" title="{{previousYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                      <span>{{previousYear | appCountableTimeZone:'MMMM d':'UTC'}}</span>
                      <span>{{previousYear | appCountableTimeZone:'yyyy':'UTC'}}</span>
                    </span>
                  </p>
              </ng-container>
            </div>

            <div class="retained-earnings-content">
              <mat-accordion #accordion="matAccordion" multi="true">
                <ng-container *ngFor="let item of retainedEarningsData; let i = index; trackBy: reParent;">
                  <mat-expansion-panel [expanded]="isSearchExist ? item.isexpand : retainedEarningsExpanded"
                    (mouseenter)="mouseEnterHandler($event, chapterExpansionPanel)" #chapterExpansionPanel
                    (keydown.Space)="$event.stopImmediatePropagation();" [ngClass]="{'brd-top': item.id == '13'}">
                    <mat-expansion-panel-header class="first-header" [ngClass]="{'total-footer' : item.trialbal === undefined, 'singleElement' : item.trialbal == undefined }" (keydown.Space)="$event.stopImmediatePropagation();">
                      <mat-panel-title>
                        <div class="flex-table-header">
                          <div class="table-left-section">
                            <p class="ft-header-cell col-toogle">
                                <span class="togglable-icon" [ngClass]="{'d-none' : item.trialbal === undefined, 'singleElement' : item.trialbal == undefined }">
                                    <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                </span>
                            </p>
                            <p class="ft-header-cell col-header-title me-auto py-0 px-2 flex-1">
                              <ng-container *ngIf="!item.isEditable">
                                <span class="text-ellipse fw-semibold">{{item.name}}</span>
                                  <ng-container *ngIf="acl?.hasEngViewEdit">
                                  <button mat-button class="button-text ms-2 hover-action-item" (click)="item.oldvalue = item.name; editingTitleCheck(item)"
                                  title="Edit" *ngIf="shortCutMenuDetails.isenglock === 0 && !isHideActionsForPY">
                                    <i class="fa-regular fa-pen fs-15"></i>
                                  </button>
                                </ng-container>
                              </ng-container>

                              <ng-container *ngIf="item.isEditable">
                                <mat-form-field class="fixed-label icon-form-after label-none action-2 form-field-smaller" floatLabel="always">
                                  <input matInput type="text" [(ngModel)]="item.name"
                                    (keydown.Space)="$event.stopImmediatePropagation();" #focusInputField required>
                                    <div matSuffix class="actions border-start">
                                      <button mat-button color="success" title="Save" [ngClass]="{'readOnly':item.name.length==0, 'btn-disabled' : !(item.name.trim())}" (click)="item.isEditable=!item.isEditable;UpdateTitles(item)"
                                      [disabled]="!(item.name.trim())">
                                        <i class="fa-regular fa-check"></i>
                                      </button>
                                      <button mat-button color="error" title="Cancel" (click)="item.name=item.oldvalue; closeTitleEdit(item)">
                                        <i class="fa-regular fa-xmark clear-icon"></i>
                                      </button>
                                    </div>
                                </mat-form-field>
                              </ng-container>
                            </p>
                          </div>
                          <p class="ft-header-cell col-leadsheet border-start"></p>
                          <p class="ft-header-cell col-map"></p>
                          <p class="ft-header-cell col-nfs border-start" *ngIf="restrictedColumn">
                            <ng-container *ngFor="let notes of item.notes|sortBy:'asc':'engNoteId' let index = index; let l = count">
                              <button mat-button class="button-text text-left" matTooltip={{notes.notename}}  matTooltipClass="ntfs-tooltip" (click)="navigateToNotesToFs(notes.engNoteId)">
                                  <div class="ls-btn" style="max-width: 65px; align-self: center;"><span
                                      class="text-link ellipse"> {{notes.engNoteId}}<span *ngIf="index+1 != l">,</span>
                                    </span></div>
                              </button>
                            </ng-container>
                          </p>
                          <p class="ft-header-cell col-current text-end" title="{{item.Currgrouptotal}}">
                            <span class="fw-semibold" [ngClass]="{'totalValue' : item.trialbal !== undefined, 'singleElement' : item.trialbal !== undefined }">{{item.Currgrouptotal}}</span>
                          </p>
                          <ng-container *ngIf="isPrevyear">
                              <p class="ft-header-cell col-previous text-end border-start" title="{{item.Prevgrouptotal}}">
                                <span class="fw-semibold" [ngClass]="{'totalValue' : item.trialbal !== undefined, 'singleElement' : item.trialbal !== undefined }">{{item.Prevgrouptotal}}</span>
                              </p>
                          </ng-container>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div cdkDropListGroup>
                      <div class="flexbox-column gap-0" cdkDropList id="{{item.id}}" [cdkDropListConnectedTo]="connectedTo" [cdkDropListData]="item.trialbal" (cdkDropListDropped)="drop($event, item)" *ngIf="item.trialbal != undefined">
                        <ng-container *ngFor="let trialbal of item.trialbal">
                            <div class="ft-row" cdkDrag [cdkDragData]="trialbal"
                                 [cdkDragDisabled]="selectedTrailBLrow.length > 1 || shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit || child2?.isuseradded == 1 && isHideActionsForPY"
                                 (mouseover)="trialbal.selected = true" (mouseout)="trialbal.selected = false">
                            <div class="table-left-section">
                              <p class="ft-cell col-status">
                                <span class="status-badge" [ngClass]="{'bg-error':trialbal.LSchange == 1}">
                                  <span class="status-badge-label">
                                    <ng-container *ngIf="trialbal.LSchange == 1">CHG</ng-container>
                                  </span>
                                </span>
                              </p>
                              <p class="ft-cell col-drag-drop" [ngClass]="{'disabled': child2?.isuseradded == 1 && isHideActionsForPY}">
                                <ng-container *ngIf="trialbal.selected && selectedLSTrailBLrow.length < 2">
                                    <ng-container *ngIf="acl?.hasEngViewEdit">
                                    <button mat-button class="button-text hover-action-item cursor-grab" *ngIf="shortCutMenuDetails.isenglock === 0">
                                        <i class="fa-solid fa-grip-dots-vertical"></i>
                                    </button>
                                  </ng-container>
                                </ng-container>
                              </p>
                              <p class="ft-cell col-checkbox">
                                  <ng-container
                                          *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showRetainedEarningsCheckbox">
                                  <mat-checkbox class="label-none" disabled></mat-checkbox>
                                </ng-container>
                                <ng-template #showRetainedEarningsCheckbox>
                                  <mat-checkbox class="label-none" [(ngModel)]="trialbal.checked" [ngModelOptions]="{standalone: true}" (ngModelChange)="checkChange(trialbal,subChildItem,  childItem.id, item)" [checked]="trialbal.checked" (click)="changePosition($event, trialbal)"></mat-checkbox>

                                  <span class="test" style="position: absolute;" [matMenuTriggerFor]="checkboxDropdown" #multipleMoveMenu="matMenuTrigger"></span>
                                  <mat-menu #checkboxDropdown="matMenu" class="bs-check-dropdown" [hasBackdrop]="false">
                                    <div class="ls-map-container" (click)="$event.stopPropagation()"
                                      (keydown.tab)="$event.stopPropagation()"
                                      (keydown.shift.tab)="$event.stopPropagation()" tabindex="-1" id="LSMAPDialog">
                                      <div class="ls-map-container-section-left">
                                        <div class="ls-left-container">
                                          <div class="ls-left-container-left">
                                            <button mat-menu-item class="arrow-right-btn ls2"
                                              [disabled]="leadsheetdisable"
                                              [ngStyle]="{'background': activeLsMove ? 'rgba(0, 0, 0, 0.04)' : ''}">Leadsheet
                                              <i class="fa-regular fa-angle-right arroe-icon"></i>
                                            </button>
                                          </div>
                                        </div>
                                        <div class="mapno-container">
                                          <div class="mapno-container-left">
                                            <button mat-menu-item class="arrow-right-btn"
                                              [ngStyle]="{'background': activeMapMove ? 'rgba(0, 0, 0, 0.04)' : ''}"
                                              (click)="activeMultiMapNo(child3, $event)">Map No.
                                              <i class="fa-regular fa-angle-right maparrow-icon"></i>
                                            </button>
                                          </div>
                                        </div>
                                        <!--<div class="group-details">
                                          <button mat-stroked-button (click)="openGroupPopup()" [disabled]="disableAddGroupButton || leadsheetdisable" class="flat-btn group-btn"><span>Create Group</span></button>
                                        </div>-->
                                      </div>
                                      <ng-container *ngIf="activeLsMove || activeMapMove">
                                        <div class="ls-map-container-section-right map-section-right">
                                          <div class="clear-icon-button flex-box-vc-hr">
                                              <button mat-icon-button class="clear-icon-btn">
                                              <i class="fa-regular fa-xmark"></i>
                                            </button>
                                          </div>
                                          <!--Latest LS to move-->
                                          <ng-container *ngIf="child3.isLeadSheet && activeLsMove">
                                            <ls-dropdown [TbLeadSheetId]="TbLeadSheetId" [parentObject]="child3"
                                              [moveType]="'MULTI'" [subscribeFrom]="'IS'"></ls-dropdown>
                                          </ng-container>
                                          <!--Latest Map No. move-->
                                          <ng-container *ngIf="child3.isMap && activeMapMove">
                                            <map-dropdown [tbMapsheetId]="tbMapSheetId" [parentObject]="child3"
                                              [moveType]="'MULTI'" [yearEnd]="selectedYearEnd"
                                              [subscribeFrom]="'IS'"></map-dropdown>
                                          </ng-container>
                                          <div class="move-button" *ngIf="hideMoveButton">
                                            <button mat-flat-button class="move-btn" color="primary"
                                              [disabled]="isDisableMoveButton"
                                              (click)="activeLsMove ? saveLeadSheetdetails():savemappingdetails()">Move</button>
                                          </div>
                                        </div>
                                      </ng-container>
                                    </div>
                                  </mat-menu>
                                </ng-template>
                              </p>
                              <p class="ft-cell col-group flex-1 px-2">
                                <span class="text-ellipse" title="{{trialbal.accountname}}">{{trialbal.accountname}}</span>
                              </p>
                            </div>
                            <p class="ft-cell col-leadsheet border-start">
                                <ng-container
                                        *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showRetainedEarningsLSBtn">
                                <button title="{{trialbal.leadsheet}}" mat-button class="button-text w-100" disabled>
                                  <span class="text-ellipse">{{trialbal.leadsheet}}</span>
                                </button>
                              </ng-container>
                              <ng-template #showRetainedEarningsLSBtn>
                                <button title="{{trialbal.leadsheet}}" mat-button
                                    class="button-text text-left w-100" [matMenuTriggerFor]="gidLeadeShaeetItems" (click)="activeLSDropdown(trialbal, 'current')">
                                    <span class="text-ellipse text-link">{{trialbal.leadsheet}}</span>
                                    <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                </button>
                                <mat-menu #gidLeadeShaeetItems="matMenu" class="ls-menu" xPosition="before">
                                  <ng-container *ngIf="trialbal.isLeadSheet && isindividualRowSaveforRE">
                                    <ls-dropdown [TbLeadSheetId]="TbLeadSheetId" [parentObject]="trialbal"
                                      [moveType]="'SINGLE'" [yearType]="'CURRENT'" [subscribeFrom]="'IS'"></ls-dropdown>
                                  </ng-container>
                                </mat-menu>
                              </ng-template>
                            </p>
                            <p class="ft-cell col-map">
                                <ng-container
                                        *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showRetainedEarningsMapBtn">
                                <button title="{{trialbal.mapname ? trialbal.mapname : '-'}}" mat-button class="button-text w-100" disabled>
                                  <span class="text-ellipse">{{trialbal.mapno}}</span>
                                </button>
                              </ng-container>
                              <ng-template #showRetainedEarningsMapBtn>
                                <button title="{{trialbal.mapname ? trialbal.mapname : '-'}}" mat-button class="button-text text-left w-100" [matMenuTriggerFor]="gridMapNumDropDown" (click)="mappingNumber(trialbal, 'current')">
                                  <span class="text-ellipse text-link">{{trialbal.mapno}}</span>
                                  <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                </button>
                                <mat-menu #gridMapNumDropDown="matMenu" class="map-menu" xPosition="before">
                                  <ng-container *ngIf="trialbal.isMap && isindividualRowSaveforRE">
                                    <map-dropdown [tbMapsheetId]="tbMapSheetId" [parentObject]="trialbal"
                                      [moveType]="'SINGLE'" [yearType]="'CURRENT'" [yearEnd]="selectedYearEnd"
                                      [subscribeFrom]="'IS'"></map-dropdown>
                                  </ng-container>
                                </mat-menu>
                              </ng-template>
                            </p>
                            <p class="ft-cell col-nfs border-start" *ngIf="restrictedColumn"></p>
                            <p class="ft-cell col-current text-end" title="{{trialbal.Currbal}}">
                              <span>{{trialbal.Currbal}}</span>
                            </p>
                            <ng-container *ngIf="isPrevyear">
                                <p class="ft-cell col-previous text-end border-start" title="{{trialbal.Prevbal}}">
                                  <span>{{trialbal.Prevbal}}</span>
                                </p>
                            </ng-container>
                          </div>
                        </ng-container>

                        <div class="panel-footer ft-row" [ngClass]="{'prev-footer': !isPrevyear, 'border-btm': retainedEarningsData.length-2 != i}">
                          <div class="table-left-section">
                            <p class="ft-cell col-status"></p>
                            <p class="ft-cell col-drag-drop"></p>
                            <p class="ft-cell col-checkbox"></p>
                            <p class="ft-cell col-group flex-1 px-2">
                              <span class="text-ellipse" title="{{item.totalname}}">{{item.totalname}}</span>
                            </p>
                          </div>
                          <p class="ft-cell col-leadsheet border-start"></p>
                          <p class="ft-cell col-map"></p>
                          <p class="ft-cell col-nfs border-start" *ngIf="restrictedColumn"></p>
                          <p class="ft-cell col-current text-end" title="{{item.Currgrouptotal}}">
                            <span class="fw-semibold">{{item.Currgrouptotal}}</span>
                          </p>
                          <!-- <ng-container *ngIf="!isDisplayCol"> -->
                            <ng-container *ngIf="isPrevyear">
                                <p class="ft-cell col-previous text-end border-start" title="{{item.Prevgrouptotal}}">
                                  <span class="fw-semibold">{{item.Prevgrouptotal}}</span>
                                </p>
                            </ng-container>
                          <!-- </ng-container> -->
                          <!-- <ng-container *ngIf="isDisplayCol">
                            <p class="ft-cell col-leadsheet border-start"></p>
                            <p class="ft-cell col-map"></p>
                            <ng-container *ngIf="isPrevyear">
                              <p class="ft-cell col-previous text-end border-start" title="{{item.Prevgrouptotal}}">
                                <span class="fw-semibold">{{item.Prevgrouptotal}}</span>
                              </p>
                            </ng-container>
                          </ng-container> -->
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                  <!-- parent footer start commented code removed on 18-12-2020 -->
                  <!-- parent footer end -->
                </ng-container>
              </mat-accordion>


              <ng-container *ngIf="roundingData$ | async as roundingDifference">
                <div class="ft-row panel-details-last">
                  <div class="table-left-section">
                    <p class="ft-cell col-status"></p>
                    <p class="ft-cell col-drag-drop"></p>
                    <p class="ft-cell col-checkbox"></p>
                    <p class="ft-cell col-group flex-1 px-2"></p>
                  </div>
                  <p class="ft-cell col-leadsheet border-start"></p>
                  <p class="ft-cell col-map"></p>
                  <p class="ft-cell col-nfs border-start" *ngIf="restrictedColumn"></p>
                  <p class="ft-cell col-current text-end" title="{{roundingDifference.cyDisplayValue}}">
                    <ng-container *ngIf="roundingDifference && roundingDifference.hasCYRoundingDifference">
                      <span class="fw-semibold text-error">{{roundingDifference.cyDisplayValue}}</span>
                    </ng-container>
                  </p>
                  <ng-container *ngIf="isPrevyear">
                      <p class="ft-cell col-previous text-end border-start" title="{{roundingDifference.pyDisplayValue}}">
                        <ng-container *ngIf="roundingDifference && roundingDifference.hasPyRoundingDifference">
                          <span class="fw-semibold text-error">{{roundingDifference.pyDisplayValue}}</span>
                        </ng-container>
                      </p>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="bs-footer hover-action flexbox-row justify-content-center" style="min-height:40px;" *ngIf="restrictedColumn">
        <p class="bs-footer-text" *ngIf="!isFooterNoteEdited">
          {{footerNote}}
        </p>
        <button mat-button class="button-text hover-action-item ms-2" (click)="editFooterNotes();"
                *ngIf="acl?.hasEngViewEdit && !isFooterNoteEdited && !isHideActionsForPY">
          <i class="fa-regular fa-pen fs-15"></i>
        </button>
        <ng-container *ngIf="isFooterNoteEdited">
            <mat-form-field class="fixed-label icon-form-after action-2 form-field-medium w-300" floatLabel="always">
              <input matInput type="text" [(ngModel)]="footerNote" #focusInputField>
              <div matSuffix class="actions border-start">
                <button mat-button color="success" title="Save" (click)="saveFooterNote()"
                [disabled]="!(footerNote.trim())" [ngClass]="[!(footerNote.trim()) ? 'btn-disabled' : '']">
                  <i class="fa-regular fa-check"></i>
                </button>
                <button mat-button color="error" title="Cancel" (click)="cancelEditFooterNote();">
                  <i class="fa-regular fa-xmark clear-icon"></i>
                </button>
              </div>
            </mat-form-field>
        </ng-container>
      </div>
    </div>
  </mat-drawer-content>

  <mat-drawer #drawer class="order-2 drawer-from-right prev-right-drawer">
    <div class="toogle-button-block button-block-right">
      <button mat-button class="button-small-icon toogle-button" (click)="drawer.toggle()"></button>
      <div class="toogle-content">
        <h6 class="title">Preview</h6>
      </div>
    </div>
    <div class="income-state-container-aside w-100 overflow-auto">
        <app-statement-of-retained-earning [headerFooterData]="headerFooterDataSubject.asObservable()"></app-statement-of-retained-earning>
      <!-- <div class="retained-earnings-container-aside-footer">
      <p class="ellipse no-marg" *ngIf="restrictedColumn" style="font-size: x-small;">
        {{footerNote}}
      </p>
    </div> -->

    </div>
  </mat-drawer>
</mat-drawer-container>
<!-- </div> -->

<span class="sort-position" [matMenuTriggerFor]="sortmenu" #sortingMenu="matMenuTrigger"></span>
<mat-menu #sortmenu="matMenu" class="sort" xPosition="after" yPosition="below" [hasBackdrop]="false">
  <div class="sorting-menu" (click)="$event.stopPropagation()">
    <div class="flex-box-left-right">
      <h5>Sort</h5>
      <button class="transparent-btn sort-close float-right" (click)="closeSort()">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div class="sorting-menu-radio">
      <mat-radio-group aria-label="Select an option" [(ngModel)]="sortGroup" [ngModelOptions]="{standalone: true}">
        <mat-radio-button class="radio-btn" (change)="disableSortBtn(s.value)" [value]="s.value"
          *ngFor="let s of sortArray"><span>{{s.name}}</span></mat-radio-button>
      </mat-radio-group>
      <div class="header-sort">
        <ng-container *ngIf="sortGroup == 'AUTO' else manualSort">
          <button mat-button class="button-text transparent-btn arrow-btns" (click)="toggleSort()">
            <i class="fa-regular fa-arrow-down"></i>
          </button>
        </ng-container>
        <ng-template #manualSort>
          <div class="sorting-btns flex-box-col">
            <div class="drop-up">
              <button class="transparent-btn man-arro-up" (click)="manualSorting('UP')" [disabled]="isDisableUpArrow">
                <span class="man-arro-up-btn" *ngIf="!isDisableUpArrow">
                   <i class="fa-regular fa-arrow-up"></i>
                  </span>
                <ng-container *ngIf="isDisableUpArrow">
                 <i class="fa-regular fa-arrow-up text-gray-3"></i>
                </ng-container>
              </button>
            </div>
            <div class="drop-down">
              <button class="transparent-btn man-arro-down" (click)="manualSorting('DOWN')"
                [disabled]="isDisableDownArrow">
                <span class="man-arro-down-btn" *ngIf="!isDisableDownArrow">
                <i class="fa-solid fa-arrow-down"></i>
                  </span>
                <ng-container *ngIf="isDisableDownArrow">
                   <i class="fa-solid fa-arrow-down text-gray-3"></i>
                </ng-container>
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="sorting-menu-head br-4">
      <div class="sorting-menu-head-header">
        <p class="head-left">Sub Group</p>
        <p class="head-right">Amount</p>
      </div>
      <div class="sorting-menu-head-selection">
        <div class="sorting-menu-head-selection-data">
          <div class="sorting-menu-head-selection-data-details" *ngFor="let sort of sortData">
            <div class="bs-check-box">
              <mat-checkbox class="create-check custom-checkbox" [(ngModel)]="sort.checked"
                [ngModelOptions]="{standalone: true}" (change)="onChangeAddManualData(sort)" *ngIf="sortGroup == 'MAN'"
                [disabled]="sortCheckboxLength > 0 ? !sort.checked : sort.checked"></mat-checkbox>
            </div>
            <p class="data-left ellipse" title="{{sort.subgroupname}}">{{sort.subgroupname}}</p>
            <p class="data-right ellipse" title="{{sort.sortvalue}}">{{sort.sortvalue}}</p>
          </div>
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <div class="full-row flex-box-right">
        <button mat-button mat-flat-button color="primary" title="Apply" [ngClass]="{'disable-button': disableSort}"
          [disabled]="disableSort" (click)="onCLickSaveSorting()">Apply</button>
      </div>
    </div>
  </div>
</mat-menu>
<!-- save lead sheet message box -->
<ng-template #saveReLeadsheetDialog>
  <div class="pd-dialog-delete" (click)="$event.stopPropagation()">
    <div class="dialogboxheader">
      <div class="flex-box header-title">
        <h1 mat-dialog-title dialogbox class="flex-box no-marg">
          <span>Move Leadsheet</span>
        </h1>
      </div>
      <button class="transparent-btn float-right" [mat-dialog-close] (click)="clearRowSelection()">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div class="delete-content">
      <p class="dialogbox">
        You are trying to move to Lead Sheet {{leadSheetName}}.
      </p>
      <p class="dialogbox">
        Do you want to continue?
      </p>
    </div>
    <div mat-dialog-actions>
      <div class="pd-delete-dialog-actions unap-yes-no">
        <button mat-flat-button mat-stroked-button class="float-left yesno-btn mar-r-16" color="secondary"
          [mat-dialog-close] (click)="clearRowSelection()">
          No
        </button>
        <button mat-flat-button class="float-right yesno-btn" color="primary" [mat-dialog-close]
          (click)="saveLeadSheetdetails()">
          Yes
        </button>
      </div>
    </div>
  </div>
</ng-template>
<!--save Map No. message box -->
<ng-template #saveReMapNoDialog>
  <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
      <h4 class="title">Move Map No.</h4>
      <button color="error" class="close" [mat-dialog-close] (click)="clearRowSelection()">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <p>You are trying to move to Map Number <span class="fw-semibold">{{mapNo}}</span>.</p>
      <p>Do you want to continue?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-medium" color="dark" [mat-dialog-close]
        (click)="clearRowSelection()">No</button>
      <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close]
        (click)="savemappingdetails()">Yes</button>
    </div>
  </div>
</ng-template>
<!--dialog layout-->

<ng-template #notesFSLinkingDialog>
  <div class="notes-fs-link-dialog">
    <div class="notes-fs-link-dialog-body">
      <div class="full-row">
        <button class="transparent-btn float-right " [mat-dialog-close]>
            <i class="fa-regular fa-xmark clear-icon"></i>
        </button>
      </div>
      <div class="dialogboxheader ">
        <h2 mat-dialog-title dialogbox>
          <span>Link Notes to Financial Statement</span>
        </h2>
      </div>
      <div class="input-document">
          <label>Financial Statement Item to Link:</label>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="notesSRc" (ngModelChange)="changednotesLinks()">
            <div style="padding: 1rem;">
              <ng-container style="padding: 1rem;">
                <div style="padding: 1rem;">
                  <mat-option class="fs-items-option" *ngFor="let option of FSItemstolink" [value]="option">
                    {{option.name}} {{option.Currgrouptotal}}
                  </mat-option>
                </div>
              </ng-container>
            </div>
          </mat-select>
        </mat-form-field>
      </div>
      <hr class="mar-b-20">
        <label>Select notes to link:</label>
      <div class="search-field bals-search">
        <form>
          <input class="mat-input-element " matinput="" maxlength="25" id="searchKeyword" name="searchKeyword"
                 [(ngModel)]="searchKeyword" (keyup.backspace)="searchNotes()"
                 (keyup)="searchNotes()" #searchField placeholder="Search" maxlength="100"
            autocomplete="off">
          <button class="transparent-btn search-btn bals-search-btn">
            <i class="fa-regular fa-magnifying-glass search-icon bals-srch-icn"></i>
          </button>
        </form>
      </div>
      <div class="mar-tb-16">
        <mat-checkbox [checked]="isSelectAll" [(ngModel)]="isSelectAll"
          (change)="selectAll($event);disablegreenbutton=false;" id="isSelectAll" name="selectAll"><span>Select
            all</span></mat-checkbox>

      </div>
      <div class="checkbox-group float-left mar-b-20 full-row">
        <div class="full-row">
          <div class="scroll-down-bar-right-side">
            <ng-container *ngFor="let category of notes; trackBy: trackByRecords;let i=index">
              <mat-accordion class="" *ngIf="category.notes" #accordion="matAccordion" multi="true">
                <mat-expansion-panel [expanded]="category.isExpand">
                  <mat-expansion-panel-header [ngClass]="{'checked': category.is_checked == true}">
                    <mat-panel-title (click)="$event.stopPropagation()">
                      <div class="signOff-left1 co-left-signoff flex-box-col" style="justify-content: space-between;">
                        <div class="left-label1">
                          <mat-checkbox (change)="is_recordChecked(i,'category');disablegreenbutton=false;"
                            [checked]="category.is_checked" (click)="$event.stopPropagation()"> </mat-checkbox>
                          <span class="numbering-catergory">{{category.engNoteId}}.</span>
                          <span class="mar-l-5 ellipse"> {{category.name}}</span>
                        </div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul>
                    <li class="mat-labelsection1 ellipse" [ngClass]="{'checked': note.is_checked == true}"
                      *ngFor="let note of category.notes;let j=index">
                      <mat-checkbox (change)="is_recordChecked(i,'subcategory',j);disablegreenbutton=false;"
                        [checked]="note.is_checked" (click)="$event.stopPropagation()">
                        <span class="mar-l-5 ellipse notes-label"><i class="fa-regular fa-subtitles"></i>
                            <span class="numbering">{{note.engNoteId}}.</span>{{note.name}}
                        </span>
                      </mat-checkbox>
                    </li>
                  </ul>
                </mat-expansion-panel>
              </mat-accordion>
              <ng-container *ngIf="!category.notes">
                <ul [ngClass]="{'checked': category.is_checked == true}">
                  <li class="mat-labelsection1 ellipse">
                    <mat-checkbox (change)="is_recordChecked(i,'category');disablegreenbutton=false;"
                      [checked]="category.is_checked" (click)="$event.stopPropagation()">
                      <span class="mar-l-5 ellipse notes-label"><span
                          class="numbering-catergory">{{category.engNoteId}}.</span>
                        <i class="fa-regular fa-subtitles"></i>
                        {{category.name}}
                      </span>
                    </mat-checkbox>
                  </li>
                </ul>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="pd-delete-dialog-actions unap-yes-no full-row">
      <button mat-flat-button class="blue-1-button" *ngIf="!disablegreenbutton" (click)="saveLinkNotes()"
        [mat-dialog-close]>Link notes {{getCheckedNotes().length>0?"("+getCheckedNotes().length+")":''}} </button>
      <button mat-flat-button class="green-1-button"
        *ngIf="getIncomesheet_Notes_Link_Obj().notes && getIncomesheet_Notes_Link_Obj().notes.length && disablegreenbutton"
        [disabled]="disablegreenbutton" (click)="saveLinkNotes()">Linked notes
        {{getCheckedNotes().length>0?"("+getCheckedNotes().length+")":''}} </button>
    </div>
  </div>
</ng-template>
